import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    createConditionDefinition,
    CreateConditionDefinitionRequest,
    UpdateConditionDefinitionRequest,
    updateConditionDefinition,
} from '../endpoints/conditionDefinitions';

export const useCreateConditionDefinitionMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (request: CreateConditionDefinitionRequest) =>
            createConditionDefinition(request),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['condition-definitions'] });
        },
    });
};

export const useUpdateConditionDefinitionMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, request }: { id: string; request: UpdateConditionDefinitionRequest }) =>
            updateConditionDefinition(id, request),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['condition-definitions'] });
        },
    });
};
